import { useEffect, useMemo } from "react";
import { PostMessageService } from "@/services/postMessage";
import { HandlerContext } from "@/services/postMessage/types";
import { POSTMESSAGE_ALLOWED_ORIGINS } from "@/config/constants";

export interface UsePostMessageOptions {
  allowedOrigins?: string[];
  enabled?: boolean;
}

export const usePostMessage = (options: UsePostMessageOptions = {}) => {
  const {
    allowedOrigins = POSTMESSAGE_ALLOWED_ORIGINS,
    enabled = true,
  } = options;

  const context = useMemo<HandlerContext>(() => {
    const isDevelopment = process.env.NODE_ENV === "development";
    const origins = [...allowedOrigins];

    if (isDevelopment && window.location.origin.startsWith("http://localhost")) {
      origins.push(window.location.origin);
    }

    return {
      allowedOrigins: origins,
      isDevelopment,
    };
  }, [allowedOrigins]);

  const service = useMemo(() => {
    if (!enabled) return null;
    return PostMessageService.getInstance(context);
  }, [enabled, context]);

  useEffect(() => {
    if (!enabled || !service) return;

    console.log("[usePostMessage] Service initialized", {
      allowedOrigins: context.allowedOrigins,
      isDevelopment: context.isDevelopment,
    });

    (window as any).PostMessageService = PostMessageService;

    return () => {
      console.log("[usePostMessage] Cleanup");
    };
  }, [enabled, service, context]);

  return service;
};
